@if ({}; as STATE) {
  <section class="ads-expenses-layout"></section>
}
